export default __webpack_public_path__ + "static/media/speakingbooster.b2231551.png";